import { getMutiVehiclePlateAmounts, getVehiclePlate } from '../../../api/elasticSearch/vehicleplateApi'
const state = {
  multiVehiclePlateAmounts: null,
  vehiclePlateSearchData: null,
  objectTypes: null
}
const getters = {
  getMutiVehiclePlateAmounts: state => {
    return state.multiVehiclePlateAmounts
  },
  getVehiclePlateSearchData: state => {
    return state.vehiclePlateSearchData
  },
  getObjectTypes: state => {
    return state.objectTypes
  }
}
const actions = {
  async updateMultiVehiclePlateAmounts({ commit }, condition) {
    commit('setMultiVehiclePlateAmounts', await getMutiVehiclePlateAmounts(condition))
  },

  async updateVehiclePlateSearchData({ commit }, condition) {
    commit('setVehiclePlateSearchData', await getVehiclePlate(condition))
  }
}
const mutations = {
  setMultiVehiclePlateAmounts(state, data) {
    state.multiVehiclePlateAmounts = data.timeUnitData
    state.objectTypes = data.objectType
  },

  setVehiclePlateSearchData(state, data) {
    state.vehiclePlateSearchData = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
